<!--
 * @Description: 用户协议配置
 * @Author: 钱磊
 * @Date: 2022-08-16 10:41:18
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-11 08:47:22
-->
<!--  -->
<template>
  <div class="h100 audit">
    <!-- 列表查询页 -->
    <filter-layout @search="doSearch" @reset="doRefresh" v-if="!routeQuery">
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="100px"
          :model="searchObj"
        >
        <el-form-item label="场景应用：" prop="sceneApply">
          <el-select
            v-model="searchObj.sceneApply"
            placeholder="请选择场景应用"
            clearable
            size="small"
          >
            <el-option
            v-for="(item, index) in yycj"
            :key="index"
            :label="item.sname"
            :value="item.value"
            :disabled="item.disabled"
            ></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="创建人：" prop="createUser">
            <el-input
              :placeholder="'请输入'"
              clearable
              v-model="searchObj.createUser"
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="content-header" v-if="!routeQuery">
          <div class="title">
            总共设置了<span class="blue">{{ searchObj.totalResult }}</span>
            项内容
          </div>
          <div class="btnGroups">
            <el-button
              class="btn-success"
              size="small"
              @click="handleTools('add')"
              >新增配置</el-button
            >
            <!-- <el-button
              type="primary"
              class="btn-blue ml10"
              size="small"
              @click="changeState"
            >
              筛选
              <i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
              <i v-else class="el-icon-caret-top ml5"></i>
            </el-button> -->
            <el-button
              size="small"
              class="btn-blue"
              icon="el-icon-refresh"
              type="primary"
              @click="doRefresh"
            ></el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page" v-if="!routeQuery">
          <div class="w-table-content" v-show="tableShow">
            <vxe-table
              :data="tableObj.tableData"
              :loading="tableObj.loading"
              :border="tableObj.border"
              :resizable="tableObj.resizable"
              :size="tableObj.size"
              :height="tableObj.height"
              highlight-current-row
              highlight-hover-row
              show-overflow="tooltip"
              v-show="tableShow"
              show-header-overflow="tooltip"
            >
              <vxe-table-column
                type="seq"
                title="序号"
                align="center"
                width="70"
              ></vxe-table-column>
              <vxe-table-column
                field="sceneId"
                title="场景ID"
                align="center"
                width="120"
                show-overflow-tooltip
              ></vxe-table-column>
              <vxe-table-column
                field="sceneApplyName"
                title="场景应用"
                align="center"
                width="180"
              >
              </vxe-table-column>
              <vxe-table-column
                field="relateDeals"
                title="关联协议"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="createUser"
                title="创建人"
                align="center"
                width="90"
              ></vxe-table-column>
              <vxe-table-column
                field="createDate"
                title="创建时间"
                align="center"
                width="160"
              >
                <template v-slot="{ row }">
                  {{ row.createDate }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                title="配置启用/关闭"
                align="center"
                width="150"
              >
                <template v-slot="{ row }">
                  <vxe-switch
                    v-model="row.status"
                    open-label="启用"
                    :open-value="1"
                    close-label="关闭"
                    :close-value="0"
                    @change="changeStatus(row)"
                  ></vxe-switch>
                </template>
              </vxe-table-column>
              <vxe-table-column title="操作" width="170" align="center">
                <template v-slot="{ row }">
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    icon="el-icon-edit"
                    v-if="row.status != 1"
                    @click="handleTools('edit', row)"
                  >
                    编辑
                  </el-button>
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    icon="el-icon-search"
                    v-else
                    @click="handleTools('check', row)"
                  >
                    查看
                  </el-button>
                  <el-button
                    type="danger"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    icon="el-icon-delete"
                    :disabled="row.status == 1"
                    @click="handleTools('delete', row)"
                    >删除
                  </el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
          <div class="w-table-footer">
            <vxe-pager
              size="mini"
              :current-page="searchObj.currentPage"
              :page-size="searchObj.pageSize"
              :total="searchObj.totalResult"
              class="text-center"
              :page-sizes="[10, 20, 50, 100]"
              :layouts="[
                'Total',
                'Sizes',
                'PrevPage',
                'JumpNumber',
                'NextPage',
                'FullJump',
              ]"
              @page-change="handlePageChange"
            >
            </vxe-pager>
          </div>
        </div>
      </template>
    </filter-layout>
    <div class="check-setting" v-else-if="routeQuery == 'check'">
      <check-agreesetting @close="doSearch"></check-agreesetting>
    </div>
    <div class="add-setting" v-else>
      <add-agreesetting @close="doSearch"></add-agreesetting>
    </div>
  </div>
</template>
<script>
import * as API from "api/modules/rulesManagement";
import { mapState } from "vuex";

import AddAgreesetting from "./add-Agreesetting.vue";
import CheckAgreesetting from "./check-Agreesetting.vue";

export default {
  data () {
    return {
      showFilter: true,
      searchObj: {
        createUser: "", // 创建人
        sceneApply: "", // 场景应用（码表）
        currentPage: 1, // 当前页码
        pageSize: 10, // 当前每页条数
        totalResult: 0,
      },
      // 表格对象
      tableObj: {
        tableData: [],
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        height: "100%",
      },
      searchToggle: true, //筛选控制
      tableShow: true, //表格显隐控制
    };
  },
  components: {
    AddAgreesetting,
    CheckAgreesetting
  },
  mounted() {
    // 如果是 返回的
    if (this.isBack) {
      if (this.$getSessionItem("searchObj")) {
        this.searchObj = JSON.parse(this.$getSessionItem("searchObj"));
        // 移除 避免污染
        this.$removeSessionItem("searchObj");
      }
      if (this.$getSessionItem("agreementInfo")) {
        // 移除 避免污染
        this.$removeSessionItem("agreementInfo");
      }
    }
    this.doSearch();
  },
  methods: {
    // 查询评价设置列表
    doSearch(page) {
      if (page) {
        this.searchObj.pageSize = 10;
        this.searchObj.currentPage = 1;
      }
      let params = {
        size: this.searchObj.pageSize, // 当前每页条数
        current: this.searchObj.currentPage, // 当前页码
        createUser: this.searchObj.createUser, // 规则名称
        sceneApply: this.searchObj.sceneApply, // 应用业务（码表）
      };
      this.tableObj.loading = true;
      API.getConfigPageList(params)
        .then((res) => {
          this.tableObj.loading = false;
          if (res.operationCode === 1) {
            this.tableObj.tableData=res.data.records;
            this.searchObj.totalResult=parseInt(res.data.total);
          }
        })
        .catch((err) => {
          this.tableObj.loading = false;
        });
    },
     // 当启用状态发生变化时
    changeStatus(row) {
      let _flag = row.status;
      row.status = row.status == 0 ? 1 : 0;
      let params = {
            id: row.id,
            status: _flag,
          };
      if(row.status == 1){
        this.$confirm(`请确认是否要关闭该配置，当前配置有可能被业务应用中，请谨慎操作`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          API.changeStatus(params)
            .then((res) => {
              if (res.operationCode === 1) {
                this.$message.success("设置成功！");
                this.doSearch();
              }
            })
            .catch((err) => {});
        })
        .catch(() => {
          this.$message.info("已取消操作！");
        });
      }else{
          API.changeStatus(params)
            .then((res) => {
              if (res.operationCode === 1) {
                this.$message.success("设置成功！");
                this.doSearch();
              }
            })
            .catch((err) => {});
      }
    },
    //刷新/重置
    doRefresh() {
      this.searchObj.pageSize = 10;
      this.searchObj.currentPage = 1;
      this.searchObj.createUser = "";
      this.searchObj.sceneApply = "";
      this.doSearch();
    },
    // 右侧操作
    handleTools(type, row) {
      switch (type) {
        case "delete":
          this.$confirm("请确认是否需要删除该配置", "删除", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              API.delConfig({ id: row.id })
                .then((res) => {
                  if (res.operationCode === 1) {
                    this.$message.success(res.msg);
                  }
                  // 刷新页面
                  this.doSearch();
                })
                .catch((err) => {});
            })
            .catch(() => {});
          break;
        case "add":
          this.$router.push({
            path: "/agreement-setting",
            query: {
              type: "add",
            },
          });
          break;
       case "edit":
          let rowObj = Object.assign({}, row);
          // 存值
          this.$setSessionItem("agreementInfo", JSON.stringify(rowObj));
          // 存值
          this.$setSessionItem("searchObj", JSON.stringify(this.searchObj));
          this.$router.push({
            path: "/agreement-setting",
            query: {
              type: "edit",
            },
          });
          break
        default:
           let checkObj = Object.assign({}, row);
          // 存值
          this.$setSessionItem("agreementInfo", JSON.stringify(checkObj));
          // 存值
          this.$setSessionItem("searchObj", JSON.stringify(this.searchObj));
          this.$router.push({
            path: "/agreement-setting",
            query: {
              type: "check",
            },
          });
      }
    },
     // 切换状态
    changeState() {
      this.searchToggle = !this.searchToggle;
    },

    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.searchObj.currentPage = currentPage;
      this.searchObj.pageSize = pageSize;
      this.doSearch();
    },
  },
  computed: {
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("app", { isBack: (state) => state.isBack }),
    ...mapState("dict", {
      yycj: (state) => state.yycj,
    }),
  },
}
</script>
<style scoped lang='less'>
.content-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  .title {
    padding-left: 10px;
    border-left: 4px solid #2671cc;
    font-size: 14px;
    color: #202020;
  }
  .blue{
    font-size: 18px;
    color: #2671cc;
  }
}
</style>
